import * as React from "react";
const MapImpl = React.lazy(() => import("./map-impl"));
/**
 * Lazy loads a map using leaflet.
 *
 * @example
 *
 * ```jsx
 * import { Map } from "@skve/components"
 *
 * function Demo() {
 *   return <Map lat={48.137154} lng={11.576124} />
 * }
 * ```
 */
export const Map = (props) => React.createElement(MapImpl, Object.assign({}, props));
const MapOverviewImpl = React.lazy(() => import("./map-overview-impl"));
export const MapOverview = (props) => (React.createElement(MapOverviewImpl, Object.assign({}, props)));
//# sourceMappingURL=map.js.map